var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { ContainerQuery } from "react-container-query";
import { marketColumnsDisplayMultiview } from "../../../../constants";
import { getMarkets, setClassNamesEventCard, renderMarketsColumnsFilter } from "../../../../helpers";
import { EventCard } from "../EventCard";
import { EventCardDetails } from "../EventCardDetails";
import { MarketsCountLink } from "../MarketsCountLink";
import { MarketsWrapMultiview } from "../MarketsWrapMultiview";
const ContainerQueryObserver = observer(ContainerQuery);
let EventCardMultiview = class EventCardMultiview extends EventCard {
    render() {
        return (React.createElement(ContainerQueryObserver, { query: marketColumnsDisplayMultiview }, params => {
            const details = Object.assign(Object.assign({}, this.props), { event: Object.assign(Object.assign({}, this.props.event), { isTeamSwap: false }), markets: getMarkets(renderMarketsColumnsFilter(this.props.sport.config.markets, params || {}), this.props.markets, this.props.event) });
            const classNames = setClassNamesEventCard(details.event.isLive, details.event.isSuspended, details.hideGameState, "ev-card");
            const cardTypeClass = details.event.cardType
                ? `rj-ev-list__ev-card--${details.event.cardType.toLowerCase()}`
                : "";
            return (React.createElement("div", { className: `rj-ev-list__ev-card ${cardTypeClass} ${classNames}`, "data-uat": "div-ev-list-ev-card" },
                React.createElement("div", { className: "rj-ev-list__ev-card__inner", "data-uat": "div-ev-list-ev-card-inner" },
                    React.createElement(EventCardDetails, { details: details, componentPrefix: "ev-card" }),
                    React.createElement(MarketsWrapMultiview, { details: details, componentPrefix: "ev-card" }),
                    React.createElement(MarketsCountLink, { details: details, componentPrefix: "ev-card" }))));
        }));
    }
};
EventCardMultiview = __decorate([
    observer
], EventCardMultiview);
export { EventCardMultiview };
//# sourceMappingURL=EventCardMultiview.js.map